export default "__VITE_ASSET__Xu6kDybt__"